import { gql } from "@apollo/client";

export const GET_ORGANIZATIONS = gql`
  query getAllOrganizations(
    $skip: Float
    $take: Float
    $filter: OrgFilterInput
  ) {
    getAllOrganizations(skip: $skip, take: $take, filter: $filter) {
      count
      result {
        id
        name
        isSeller
        isVerified
        leagalName
        phoneNo
        feature
        locations {
          isPrimary
          name
          stateName
          cityName
        }
        sellers {
          id
          displayName
          isVerified
          roles {
            id
            key
          }
          userOrg {
            isIndividual
            id
          }
          currentOrganization {
            orgSubscriptions {
              id
              status
              sellerFee
              subscriptions {
                id
                name
              }
            }
          }
        }
        orgSubscriptions {
          status
          subscriptions {
            id
            name
          }
        }
        orgAssetManagers {
          isPrimary
          assetManagers {
            id
            displayName
          }
        }
      }
    }
  }
`;

export const GET_ORGANIZATIONS_BY_ID = gql`
  query getOrganizationById($oraganizationId: String!) {
    getOrganizationById(oraganizationId: $oraganizationId) {
      id
      name
      leagalName
      sellerFee
      offerThreshold
      isSeller
      feature
      orgSubscriptions {
        id
        status
        feature
        subscriptionPrice {
          id
          price
        }
        subscriptions {
          id
          title
          key
          sellerFee
          feature
        }
      }
    }
  }
`;

export const GET_ALL_ORGANIZATIONS = gql`
  {
    getAllOrganizations {
      result {
        id
        name
      }
    }
  }
`;

export const GET_BUYER_SELLER = gql`
  query listBuyerOrSeller(
    $skip: Float!
    $take: Float!
    $filter: UserFilterInput
  ) {
    listBuyerOrSeller(skip: $skip, take: $take, filter: $filter) {
      count
      result {
        id
        displayName
        firstName
        lastName
        email
        isActive
        isInvited
        isDeleted
        isEmailVarified
        phoneno
        roles {
          id
          role
        }
        currentOrganization {
          id
          name
        }
        userOrg {
          id
          users {
            id
          }
          isIndividual
          isDeleted
          organization {
            id
            name
            isDeleted
          }
          roles {
            key
            role
          }
        }
      }
    }
  }
`;

export const GET_BUYER_SELLER_BY_ID = gql`
  query getUserId($userId: String!) {
    getUserById(userId: $userId) {
      id
      firstName
      lastName
      email
      roles {
        id
        role
      }
      currentOrganization {
        id
        name
      }
      displayName
      phoneno
      createdAt
    }
  }
`;

export const ADD_ORGANISATION_SUBSCRIPTION = gql`
  mutation addOrganizationSubscription(
    $subscriptionId: String!
    $orgId: String!
  ) {
    addOrganizationSubscription(
      subscriptionId: $subscriptionId
      orgId: $orgId
    ) {
      userOrg {
        organization {
          leagalName
          name
          phoneNo
          id
        }
      }
    }
  }
`;

export const SUPER_ADMIN_SEND_SUBSCRIPTION = gql`
  mutation superadminSendSubscriptionLink(
    $organizationId: String!
    $subscriptionId: String!
  ) {
    superadminSendSubscriptionLink(
      subscriptionId: $subscriptionId
      organizationId: $organizationId
    ) {
      userOrg {
        organization {
          leagalName
          name
          phoneNo
          id
        }
      }
    }
  }
`;
export const GET_ALL_LOGISTIC_TYPE = gql`
  query getAllLogistics($skip: Float!, $take: Float!) {
    getAllLogistics(skip: $skip, take: $take) {
      count
      result {
        id
        name
        isDeleted
      }
    }
  }
`;

export const GET_ALL_LOGISTIC_PARTNER = gql`
  query getAllLogisticsPartner($skip: Float!, $take: Float!) {
    getAllLogisticsPartner(skip: $skip, take: $take) {
      count
      result {
        id
        name
        isDeleted
      }
    }
  }
`;
export const GET_ALL_FINANCE_PARTNER = gql`
  query getAllFinancePartner($skip: Float!, $take: Float!) {
    getAllFinancePartner(skip: $skip, take: $take) {
      count
      result {
        id
        name
        isDeleted
      }
    }
  }
`;
export const GET_ALL_SERVICE_OFFERED = gql`
  query getAllFinance($skip: Float!, $take: Float!) {
    getAllFinance(skip: $skip, take: $take) {
      count
      result {
        id
        name
        isDeleted
      }
    }
  }
`;

export const GET_LOCATION_BY_ORGANIZATION_ID = gql`
  query getAllLocationByOrganizationId($organizationId: String!) {
    getAllLocationByOrganizationId(organizationId: $organizationId) {
      id
      name
      lat
      long
      isPrimary
    }
  }
`;
